import React from 'react'

const WhyOrcimedScreen = () => {
  return (
    <div>WhyOrciMedScreen</div>
  )
}

export default WhyOrcimedScreen